import * as React from 'react';

import BaseSettingsLayout from './BaseSettingsLayout';
import SettingsLegal from '../containers/settings/SettingsLegal';

export default function () {
  return BaseSettingsLayout(
    <SettingsLegal />
  );
};
